import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  CustomValidators,
  FormServiceValidationMessages,
  ViggoCoreCustomInputComponent
} from 'viggo-sistemas-core-web';

import { merge } from 'rxjs';

import { Utils } from '@app/shared/helpers/utils';
import { IParceiroContato } from '../../model/parceiro.model';

export interface IDialogNovoContatoData {
  contato: IParceiroContato;
}

@Component({
  selector: 'dialog-novo-contato',
  templateUrl: './dialog-novo-contato.component.html',
  styleUrls: ['./dialog-novo-contato.component.scss']
})
export class DialogNovoContatoComponent implements OnInit {
  @ViewChild(ViggoCoreCustomInputComponent)
  input: ViggoCoreCustomInputComponent;

  teclasSeparadoras = [ENTER, COMMA, SPACE];
  form: UntypedFormGroup;
  tagsBck: string | string[];
  // tagsObjBck: any[]; //TODO: TAGLIST DE PRODUTO
  formTag: UntypedFormArray;
  displayMessage;
  validatorMensagens: FormServiceValidationMessages;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDialogNovoContatoData,
    protected fb: UntypedFormBuilder,
    public dialog: MatDialogRef<DialogNovoContatoComponent, IParceiroContato>
  ) {
    this.validatorMensagens = new FormServiceValidationMessages({
      contato: {
        required: 'O Contato é obrigatório',
        isEmptyValue: 'Valor inválido: remova os espaços em branco!',
        maxlength: 'O Contato aceita no máximo 100 caracteres'
      }
    });
  }

  ngOnInit(): void {
    this.displayMessage = {};

    const { contato } = this.data;
    this.tagsBck = contato.tag;
    // this.tagsObjBck = contato.tags;
    this.form = this.fb.group({
      contato: [
        contato.contato,
        [
          Validators.required,
          Validators.maxLength(100),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      this.displayMessage = this.validatorMensagens.getMessagesForm(this.form);
    }
    this.formTag = this.form.controls.tag as UntypedFormArray;
  }

  ngAfterViewInit(): void {
    const controlBlurs = this.input.blur;
    merge(this.form.valueChanges, controlBlurs).subscribe(() => {
      this.displayMessage = this.validatorMensagens.getMessagesForm(this.form);
    });
  }

  cancelar(): void {
    this.data.contato.tag = this.tagsBck;
    // this.data.contato.tags = this.tagsObjBck;
    this.dialog.close(
      this.data.contato.contato === ''
        ? undefined
        : Utils.trimAttributes({ ...this.data.contato })
    );
  }

  salvar(): void {
    if (Array.isArray(this.data.contato.tag))
      this.data.contato.tag = this.data.contato.tag.join(' ');
    // if (this.tagsBck.length > this.data.contato.tag.length) {
    // const prevValue = this.data.contato.tags;
    // const index = this.data.contato.tags.findIndex(
    //   t => t.value === this.tagsBck
    // );
    // if (index >= 0) {
    //   prevValue.splice(index, 1);
    //   this.data.contato.tags = prevValue;
    // }
    // }
    this.dialog.close({ ...this.data.contato, ...this.form.value });
  }

  /**
   * Salva as informações vindas do component de tag
   */
  onChangeTag(value): void {
    const { contato } = this.data;
    contato.tag = value;
    // contato.tag = value.map(t => t.value);
    // contato.tags = value;
  }
}
